/** "20H AGO"-style relative stamp for the conversation list. Input is a unix timestamp in SECONDS
 *  (what conversation_store writes via time.time()), not milliseconds. */
export function timeAgo(epochSeconds) {
  if (!epochSeconds) return "";
  const secs = Math.max(0, Math.floor(Date.now() / 1000 - epochSeconds));
  if (secs < 60) return "JUST NOW";
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}M AGO`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}H AGO`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}D AGO`;
  return new Date(epochSeconds * 1000).toLocaleDateString();
}
